type AlertMessageProps = {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
};

// TODO: Add close alert button on later phases.
const AlertMessage = ({ message, type }: AlertMessageProps) => {
  const alertClass = {
    success: 'border-green-500 text-green-700 bg-green-100',
    error: 'border-red-500 text-red-700 bg-red-100',
    warning: 'border-orange-500 text-orange-700 bg-orange-100',
    info: 'border-blue-500 text-blue-700 bg-blue-100',
  };

  return (
    <div className={`text-sm border-l-4 p-3 ${alertClass[type]}`}>
      <p>{message}</p>
    </div>
  );
};

export default AlertMessage;
